import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Input, InputAdornment } from '@material-ui/core';
import { Search } from '@material-ui/icons';

class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onClearSearch = this.onClearSearch.bind(this);
    
    this.state = { textFieldValue: '' };
  }

  onChange(e) {
    this.setState({ textFieldValue: e.target.value });
  }

  onClearSearch() {
    this.setState({ textFieldValue: '' });
  }

  render() {
    return (
      <form
        onSubmit={(event) => {
          event.preventDefault();
          if (!this.props.disabled) {
            this.props.onSearch(event.target.query.value);
          }
        }}
      >
        <FormControl fullWidth className="search-bar">
          <Input
            fullWidth
            name="query"
            placeholder={this.props.placeHolder}
            disabled={this.props.disabled}
            onChange={this.onChange}
            value={this.state.textFieldValue || ''}
            startAdornment={
              <InputAdornment position="start">
                <Search style={{ color: 'grey' }} />
              </InputAdornment>
            }
          />
        </FormControl>
      </form>
    );
  }
}

SearchBar.propTypes = {
  onSearch: PropTypes.func.isRequired,
  placeHolder: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};

export default SearchBar;
